const auto = {
  test: (v) => v === "auto",
  parse: (v) => v
};
export {
  auto
};
//# sourceMappingURL=type-auto.js.map
